import React, { useState } from 'react'
import Container from '../../../ui/comp/Container'
import Input from '../../../ui/forms/Input'
import TextArea from '../../../ui/forms/TextArea'
import Button from '../../../ui/comp/Button'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Axios } from '../../../utils/Axios'
import toast from 'react-hot-toast'
import { FaPen, FaTrash } from 'react-icons/fa'

function Faq() {

    const [formData, setFormData] = useState({ id: "", question: "", answer: "" })
    const queryClient = useQueryClient()

    const { data: faqs } = useQuery({
        queryKey: ['faqs'],
        queryFn: async () => {
            const res = await Axios.get('/store/faq')
            return res.data;
        }
    })


    // Add Faq
    const { mutate } = useMutation({
        mutationFn: (payload) => {
            return Axios.post('/store/faq', payload)
        },
        onSuccess: () => {
            setFormData({ id: "", question: "", answer: "" })
            toast.success("Sucessfull")
            queryClient.invalidateQueries(['faqs'])
        },
        onError: (error) => {
            toast.error(error?.response?.data || error?.message)
        }
    })

    const addFaq = () => {
        mutate(formData)
    }


    // Delete
    const { mutate: remove } = useMutation({
        mutationFn: (payload) => {
            return Axios.delete('/store/faq', { params: { id: payload } })
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['faqs'])
            toast.success("Deleted")
        },
        onError: (error) => {
            toast.error(error?.response?.data || error?.message)
        }
    })

    const deleteFaq = (id) => {
        if (window.confirm("Are you sure")) {
            remove(id)
            return
        }
    }

    return (
        <div className='w-full relative'>
            <Container>
                {/* Head */}
                <div className="flex flex-col gap-5">
                    {/* Question */}
                    <div className="w-full">
                        <p className="text-sm mb-2">Question</p>
                        <Input
                            placeholder="Question"
                            value={formData.question}
                            onChange={(e) => setFormData({ ...formData, question: e.target.value })}
                        />
                    </div>
                    {/* Answer */}
                    <div className="w-full">
                        <p className="text-sm mb-2">Answer</p>
                        <TextArea
                            placeholder="Answer"
                            value={formData.answer}
                            onChange={(e) => setFormData({ ...formData, answer: e.target.value })}
                        />
                    </div>
                    {/* Submit */}
                    <div className="w-full">
                        <Button onClick={addFaq}>{formData?.id ? "Update" : "Add"}</Button>
                    </div>
                </div>
                {/* Data */}
            </Container>


            <div className="mt-7">
                {faqs && faqs?.length && (
                    <div className="w-full space-y-2">
                        <Container>
                            <div className="space-y-5">
                                {faqs?.map((faq, i) => (
                                    <div key={i} className="w-full space-y-1 p-4 bg-gray-50 rounded-2xl">
                                        <h2 className="font-medium">{faq?.question}</h2>
                                        <p className="text-xs text-gray-500">{faq?.answer}</p>
                                        <div className="flex gap-2 pt-2 text-xs">
                                            <button
                                                onClick={() => setFormData(faq)}
                                                className='size-7 flex items-center justify-center text-white rounded-md bg-primary'
                                            >
                                                <FaPen />
                                            </button>
                                            <button
                                                onClick={() => deleteFaq(faq?.id)}
                                                className='size-7 flex items-center justify-center text-white rounded-md bg-red-600'
                                            >
                                                <FaTrash />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Container>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Faq